export default "__VITE_ASSET__XZYb7VTo__"